import { HHButton, HHStack } from '@hinge-health/react-component-library';
import {
  CONFIGURATION_STATUS_TRANSITIONS,
  CONFIGURATION_STATUS_TRANSITION_LABELS,
} from '../constants/partner-data-gateway.constant';
import { ConfigurationStatus } from '../domain/enums';

export const CONFIGURATION_STATUS_ACTIONS_TEST_ID =
  'pdg-configuration-status-actions';

export const configurationStatusActionTestId = (
  target: ConfigurationStatus,
  prefix: string = CONFIGURATION_STATUS_ACTIONS_TEST_ID,
): string => `${prefix}-${target.toLowerCase()}-button`;

export interface ConfigurationStatusActionsProps {
  status: ConfigurationStatus;
  /**
   * Reports the transition the operator picked. Confirmation and the
   * mutation itself are owned by the caller, so the list page and the
   * detail page can share these buttons while wiring their own dialog.
   */
  onSelect: (target: ConfigurationStatus) => void;
  disabled?: boolean;
  testIdPrefix?: string;
}

/**
 * Buttons for the transitions PDGS allows out of the current status.
 * `DELETED` is terminal, so it renders nothing at all rather than a row of
 * disabled buttons implying the state could still change.
 */
export const ConfigurationStatusActions = ({
  status,
  onSelect,
  disabled = false,
  testIdPrefix = CONFIGURATION_STATUS_ACTIONS_TEST_ID,
}: ConfigurationStatusActionsProps): JSX.Element => (
  <HHStack direction="row" gap={1} data-testid={testIdPrefix}>
    {CONFIGURATION_STATUS_TRANSITIONS[status].map(target => (
      <HHButton
        key={target}
        hhVariant="variant-bypass"
        variant={target === ConfigurationStatus.Deleted ? 'text' : 'outlined'}
        color={target === ConfigurationStatus.Deleted ? 'error' : 'primary'}
        size="small"
        disabled={disabled}
        onClick={(): void => onSelect(target)}
        data-testid={configurationStatusActionTestId(target, testIdPrefix)}
      >
        {CONFIGURATION_STATUS_TRANSITION_LABELS[target]}
      </HHButton>
    ))}
  </HHStack>
);
